import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { ArrowIconSmall } from "assets/svg";

import { Button, Textarea } from "uikit";

import { Container } from "./styles";

interface IProps {
  onSend: (value: string) => Promise<string | undefined>;
  isLoading: boolean;
}

export const AiChatInput: FC<IProps> = ({ onSend, isLoading }) => {
  const translationPrefix = `ai_assistant_pages.shared.chat_input`;
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const shouldDisableSubmit = !value.trim() || isLoading;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setValue("");
    const sentMessage = await onSend(value.trim());
    if (sentMessage) setValue(sentMessage);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLFormElement>) => {
    if (e.key === "Enter" && !e.shiftKey && !shouldDisableSubmit) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Container onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
      <Textarea
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t(`${translationPrefix}.placeholder`)}
        alwaysShowErrorBlock={false}
        $size="small"
      />

      <Button
        $size="small"
        type="submit"
        data-testid="ai-assistant-modal-send-button"
        disabled={shouldDisableSubmit}
      >
        <ArrowIconSmall />
      </Button>
    </Container>
  );
};
